// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3XRLc","info":"UpdateTermsInfo_info__2fzip"};